module.exports = __webpack_public_path__ + "static/media/icon_search_black.33fb3724.png";